import { useState } from "react";
import { useSelector } from "react-redux";

import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import PortalNavbar from "./PortalNavbar";
import PortalSidebar from "./PortalSidebar";
import { Suspense } from "react";
import Spinner from "src/components/Spinner";
import { useAppState } from "src/hooks/appState";

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
});

const MainStyle = styled("div")(({ theme, appbarMobile, appbarDesktop }) => ({
  flexGrow: 1,
  minHeight: "100%",
  paddingTop: appbarMobile,
  [theme.breakpoints.up("md")]: {
    paddingTop: appbarDesktop,
  },
}));

export default function PortalLayout() {
  const { appbarMobile, appbarDesktop } = useAppState();
  const [open, setOpen] = useState(false);

  const { user } = useSelector((state) => state.auth);

  return (
    <Suspense fallback={<Spinner fixedPosition={true} />}>
      <RootStyle>
        <PortalNavbar user={user} onOpenSidebar={() => setOpen(true)} />
        <PortalSidebar
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
        />
        <MainStyle appbarMobile={appbarMobile} appbarDesktop={appbarDesktop}>
          <Suspense fallback={<Spinner fixedPosition={true} />}>
            <Outlet />
          </Suspense>
        </MainStyle>
      </RootStyle>
    </Suspense>
  );
}
